import { call, put, takeLatest } from "redux-saga/effects";
import { postalAreas as postalAreasService } from "us.common/services";
import { PostalAreas } from "us.common/constants";
import * as Action from "us.common/actions";
import _, { omit } from "lodash";
import { $Message, $MessageBox } from "us.common/components";
import API from "us.common/services";
import { i18n } from "us.helper";

const {
  entity,
  postalAreas: { postalAreas, postalArea, deletePostalArea },
} = Action;

const postalAreasSagas = {
  postalAreas: {
    get: function* (action: any): Generator<any, void, any> {
      try {
        const { data, status } = yield call(
          postalAreasService.postalAreas.get,
          {}
        );
        if (Array.isArray(data)) {
          yield put(postalAreas.success(data));
        } else {
          yield put(postalAreas.fail([]));
        }
      } catch (error) {
        yield put(postalAreas.fail([]));
      }
    },
  },
  postalArea: {
    save: function* (action: any): Generator<any, void, any> {
      const params = action.payload.data;
      const { countryCode, disableFilterByCountryCode } = params ?? {};
      try {
        const data = yield call(
          postalAreasService.postalAreas.save,
          omit(params, ["disableFilterByCountryCode"])
        );
        if (data?.hasOwnProperty("postalCodeId")) {
          if (params.postalCodeId === -1) {
            $MessageBox(
              "success",
              "US.COLLECTION.COMMON:ENTITYSELECTION.SUCCESSFULLY_ADDED",
              "",
              ""
            );
          } else {
            $MessageBox(
              "success",
              "US.COLLECTION.COMMON:ENTITYSELECTION.SUCCESSFULLY_UPDATED",
              "",
              ""
            );
          }

          yield put(postalArea.success(data));
          if (postalArea.openDrawer) {
            yield put(
              postalArea.openDrawer({
                visible: false,
                action: "NEW",
                record: null,
              })
            );
          }
          const fetchParams = {
            countryCode: disableFilterByCountryCode ? "" : countryCode ?? "",
            searchText: "",
            searchBy: "",
          };
          const postalCodes = yield call(
            API.entityDetails.getPostelArea,
            fetchParams
          );
          if (Array.isArray(postalCodes)) {
            yield put(entity.getPostalAreasSuccess(postalCodes));
          } else {
            yield put(entity.getPostalAreasFail([]));
          }
        } else if (data?.message?.includes("postalCode is Already Exists")) {
          yield put(postalArea.fail({}));
          $MessageBox(
            "error",
            "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_IS_ALREADY_EXIXTS",
            "",
            ""
          );
        } else {
          yield put(postalArea.fail({}));
          $MessageBox(
            "error",
            "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_REGISTRATION_FAIL",
            "",
            ""
          );
        }
      } catch (error) {
        yield put(postalArea.fail(error as any));
      }
    },
  },
  deletePostalArea: {
    delete: function* (action: any): Generator<any, void, any> {
      const { data, countryCode } = action.payload?.data;
      const { postalCodeId } = data;
      $Message.loading(i18n.t("COMMON.DELETING") as string, 0);
      try {
        const { data, status } = yield call(
          postalAreasService.postalAreas.delete,
          { postalcodeId: postalCodeId }
        );
        if (status === 200 || status === 204) {
          yield put(deletePostalArea.success(data));
          const params = {
            countryCode: countryCode ?? "",
            searchText: "",
            searchBy: "",
          };
          const postalAreasData = yield call(
            API.entityDetails.getPostelArea,
            params
          );
          if (Array.isArray(postalAreasData)) {
            yield put(entity.getPostalAreasSuccess(postalAreasData));
          } else {
            yield put(entity.getPostalAreasFail([]));
          }
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.COMMON:ENTITYSELECTION.SUCCESSFULLY_DELETED",
            "",
            ""
          );
        } else {
          yield put(deletePostalArea.fail(data));
          $Message.destroy();
          if (data?.message?.includes("already in use")) {
            $MessageBox(
              "error",
              "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_IS_ALREADY_IN_USE",
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_DELETION_FAIL",
              "",
              ""
            );
          }
        }
      } catch (error) {
        yield put(deletePostalArea.fail(error as any));
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_DELETION_FAIL",
          "",
          ""
        );
      }
    },
  },
};

export default [
  takeLatest(PostalAreas.GET_POSTAL_AREAS, postalAreasSagas.postalAreas.get),
  takeLatest(PostalAreas.SAVE_POSTAL_AREA, postalAreasSagas.postalArea.save),
  takeLatest(
    PostalAreas.DELETE_POSTAL_AREA,
    postalAreasSagas.deletePostalArea.delete
  ),
];
